import { BaseEntity } from '../../../../models';
import { EnumRelevancia } from '../../../../domains/core/settings/portfolio/enums/relevancia.enum';
import { IConcorrenteRef } from '../../../../domains/environment/concorrentes/interfaces/concorrente-ref.interface';

export class ClienteConcorrente implements BaseEntity {
    readonly id: number;
    idCliente: number;
    sequencia: number;
    idConcorrente: number
    concorrente: IConcorrenteRef;
    relevancia: EnumRelevancia;

    // DEPRECATED
    // percParticipacao: number;
    // mediaCompra: number;
}
